import { render, staticRenderFns } from "./SelectCustomerCategory.vue?vue&type=template&id=7e085f87&scoped=true&"
import script from "./SelectCustomerCategory.vue?vue&type=script&lang=js&"
export * from "./SelectCustomerCategory.vue?vue&type=script&lang=js&"
import style0 from "./SelectCustomerCategory.vue?vue&type=style&index=0&id=7e085f87&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e085f87",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
